import React from 'react';
import type { TrainingMuscleVolume, TrainingSummaryMetric } from '../../../../types/training';
import styles from './TrainingSummaryPanel.module.css';

interface TrainingSummaryPanelProps {
  metrics: TrainingSummaryMetric[];
  muscleVolumes: TrainingMuscleVolume[];
  isLoading?: boolean;
  errorMessage?: string;
}

const TrainingSummaryPanel: React.FC<TrainingSummaryPanelProps> = ({
  metrics,
  muscleVolumes,
  isLoading = false,
  errorMessage = '',
}) => {
  const muscleColumnCount = Math.min(3, Math.max(1, muscleVolumes.length));
  const muscleRowCount = Math.ceil(muscleVolumes.length / muscleColumnCount);
  const muscleGridStyle = {
    '--muscle-columns': String(muscleColumnCount),
    '--muscle-rows': String(muscleRowCount),
  } as React.CSSProperties;

  return (
    <div className={styles.container}>
      <div className={styles.metricsGrid}>
        {metrics.map((item) => (
          <div key={item.label} className={styles.metricCard}>
            <span className={styles.metricLabel}>{item.label}</span>
            <span className={styles.metricValue}>{item.value}</span>
          </div>
        ))}
      </div>

      {(isLoading || errorMessage) && (
        <div className={styles.statusRow} aria-live="polite">
          <span className={errorMessage ? styles.errorText : styles.loadingText}>
            {errorMessage || 'Atualizando resumo...'}
          </span>
        </div>
      )}

      <div className={styles.sectionLabel}>Volume por grupamento muscular</div>

      {muscleVolumes.length === 0 ? (
        <div className={styles.emptyState}>Nenhum grupamento calculado.</div>
      ) : (
        <div className={styles.muscleGrid} style={muscleGridStyle}>
          {muscleVolumes.map((item) => (
            <div key={item.label} className={styles.muscleRow}>
              <span className={styles.muscleLabel}>{item.label}</span>
              <span className={styles.muscleValue}>{item.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrainingSummaryPanel;
